<template>
  <div :class="['floating-player', 'unselectable', 'elevation-12']" :hidden="$root.playerMinimized">
    <v-card :class="['elevation-12', 'transparent']">
      <v-card-title :class="['pa-1', `white--text`, 'transparent', 'floating-player-titlebar']">
        <v-icon :class="['drag-handle']">mdi-drag-vertical</v-icon>
        <div v-html="$lang.player" :class="['pl-2', 'body-2', 'font-weight-medium']" />
        <v-spacer />
        <v-btn flat small icon :class="['ma-0']" @click="minimizePlayer" :title="$lang.togglePlayer(expanded)">
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
        <v-btn flat small icon :class="['ma-0']" @click="$emit('close')" :title="$lang.closePlayer">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text :class="['pa-0', 'grey', 'darken-4']">
        <iframe title="bandcamp-embedded-player" seamless :src="makeBandCampPlayerUrl(album)" />
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Draggable from 'draggable'
import methods from '../mixins/methods'

export default {
  name: 'FloatingPlayer',
  mixins: [
    methods
  ],
  data () {
    return {
      Draggable,
      expanded: true
    }
  },
  mounted () {
    /* eslint-disable no-new */
    const iframeElement = document.querySelector('.floating-player .v-card__text').classList
    const pointerEventsNone = 'pointer-events-none'
    new Draggable(document.querySelector('.floating-player'), {
      limit: document.querySelector('.floating-player-bounds'),
      setPosition: false,
      handle: document.querySelector('.drag-handle'),
      onDrag () {
        iframeElement.add(pointerEventsNone)
      },
      onDragEnd () {
        iframeElement.remove(pointerEventsNone)
      }
    })
  },
  props: {
    album: {
      type: [
        String,
        Number
      ],
      required: true
    }
  },
  methods: {
    minimizePlayer () {
      const root = this.$root
      root.playerMinimized = true
      root.notification = true
      root.notificationText = this.$lang.playerMinimized
      this.gtagEvent('player', 'minimize')
    }
  }
}
</script>
<style>
.floating-player
{
  position: fixed;
  top: 64px;
  left: 16px;
  overflow: hidden;
  border-radius: 8px;
  z-index: 10;
  border: solid 1px #673ab7;
}

.floating-player iframe
{
  display: block;
  border: 0;
  width: 280px;
  height: 472px;
}

.floating-player .drag-handle
{
  cursor: move;
}

.floating-player .floating-player-titlebar
{
  backdrop-filter: blur(6px);
}

.floating-player-bounds
{
  position: fixed;
  opacity: .2;
  top: 0;
  pointer-events: none;
  width: 100%;
  height: 100%;
  z-index: -1;
}
</style>



// WEBPACK FOOTER //
// src/components/floating-player.vue